import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";

import Guard from "../containers/guard";
import ActionContainer from "../containers/actionContainer";
import ContactInformation from "../../../components/stepThree/contactInfoV3";
import Button from "../containers/button";

import { defaultAction } from "../../../actions/defaultAction";

import styled from "@emotion/styled";
import InfoIcon from "../containers/icons/info";

import {
  enteredCardsValidateSelector,
  contactInfoValidateSelector,
  cartIsEmptySelector,
  sellVerificationSelector,
  customerInfoSelector,
  cartSelector,
} from "../../../selectors";

import {
  SELL_VERIFICATION_SET_EMAIL,
  HIDE_SELL_VERIFICATION_EMAIL_ERROR,
  HIDE_SELL_VERIFICATION_PHONE_ERROR,
  SELL_VERIFICATION_SET_PHONE,
  SELL_VERIFICATION_SET_PHONE_ERROR,
  SELL_VERIFICATION_SET_EMAIL_ERROR,
} from "../../../constants/actionTypes";

const Message = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;

  p {
    margin-left: 1rem;
    font-size: 10px;
  }
`;

const Identity = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    config,
    cartSell,
    customerInfo,
    sellVerification,
    enteredCardsValidate,
    contactInfoValidate,
    cartIsEmpty,
    store,
  } = useSelector(
    (state) => ({
      config: state.config,
      cartSell: cartSelector(state),
      customerInfo: customerInfoSelector(state),
      sellVerification: sellVerificationSelector(state),
      enteredCardsValidate: enteredCardsValidateSelector(state),
      contactInfoValidate: contactInfoValidateSelector(state),
      cartIsEmpty: cartIsEmptySelector(state),
      store: state.store,
    }),
    shallowEqual
  );

  return (
    <Guard
      condition={!cartIsEmpty && enteredCardsValidate}
      redirect={"/card-details"}
    >
      <ActionContainer title={config.identityTitle} goBack={true}>
        <React.Fragment>
          <Message>
            <>
              {config.layoutVersion !== 2 && config.identityTxt && <InfoIcon />}{" "}
              <p>{config.identityTxt}</p>
            </>
          </Message>
          <ContactInformation
            cartSell={cartSell}
            config={config}
            sellVerification={sellVerification}
            customerInfo={customerInfo}
            hideEmailError={() =>
              dispatch(defaultAction(HIDE_SELL_VERIFICATION_EMAIL_ERROR))
            }
            setEmail={(v) =>
              dispatch(
                defaultAction(
                  SELL_VERIFICATION_SET_EMAIL,
                  v.replace(/^[\s\uFEFF\xA0]+/g, "")
                )
              )
            }
            hidePhoneError={() =>
              dispatch(defaultAction(HIDE_SELL_VERIFICATION_PHONE_ERROR))
            }
            setPhone={(phoneNum) =>
              dispatch(defaultAction(SELL_VERIFICATION_SET_PHONE, phoneNum))
            }
            setPhoneError={() =>
              dispatch(defaultAction(SELL_VERIFICATION_SET_PHONE_ERROR))
            }
            setEmailError={() =>
              dispatch(defaultAction(SELL_VERIFICATION_SET_EMAIL_ERROR))
            }
            store={store}
          />
        </React.Fragment>
        <React.Fragment>
          <Button
            active={!contactInfoValidate}
            onClick={() => {
              setIsSubmitting(true);
              history.push(
                config.paymentType === "donation"
                  ? "/identity-billing-info"
                  : "/identity-card-info"
              );
            }}
            disabled={isSubmitting || contactInfoValidate}
          >
            {config.identityContinueButtonTxt}
          </Button>
        </React.Fragment>
      </ActionContainer>
    </Guard>
  );
};

export default Identity;
